<template>
  <cs-app
    :showHeader="isLoggedIn"
    :sideNavWidth="sideNavWidth"
    customerLogoUri="https://s3-us-west-2.amazonaws.com/develop.contentengine.compliengine.com/client-assets/212/db2d3267f4d3c75aaedbd8351433c04e-small.png"
    customerName="Complispace"
    :feedbackBtn="feedbackBtn"
    :helpBtn="helpBtn"
    :searchBtn="searchBtn"
    :updateBtn="updateBtn"
    :viewBtn="viewBtn"
    :version="version"
  >
    <template v-slot:header-menu>
      <slot-indicator slot-name="Menu" width="auto" height="auto"></slot-indicator>
    </template>

    <template v-slot:header-left>
      <slot-indicator slot-name="Call to action" width="auto" height="auto"></slot-indicator>
    </template>

    <template v-slot:header-right>
      <cs-header-icon-btn :id="finger" toolTip="Finger" :btn="fingerBtn">
        <template v-slot:header-btn-icon>
          <cs-svg-finger></cs-svg-finger>
        </template>
      </cs-header-icon-btn>
    </template>

    <template v-slot:header-helper>
      <slot-indicator slot-name="Call to action" width="auto" height="auto"></slot-indicator>
    </template>

    <template v-slot:header-settings>
      <slot-indicator slot-name="Call to action" width="auto" height="auto"></slot-indicator>
    </template>

    <template v-slot:header-settings-menu>
      <slot-indicator slot-name="Call to action" width="auto" height="auto"></slot-indicator>
    </template>

    <template v-slot:side-nav>
      <slot-indicator slot-name="Call to action" width="auto" height="20rem">
        <template v-slot:content>
          <v-container fluid>
            <v-row align="center">
              <v-col class="d-flex">
                <v-select
                  :items="items"
                  dense
                  solo
                  label="Select View Type"
                  v-model="viewType"
                ></v-select>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col md class="d-flex">
                <v-btn width="100%" @click.stop.prevent="onHideSideNav">Hide Side Nav</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </slot-indicator>
    </template>

    <template v-slot:router-view>
      <v-slide-y-transition>
        <router-view></router-view>
      </v-slide-y-transition>
    </template>

    <template v-slot:footer>
      <div class="content">
        <v-layout align-center justify-center column fill-height>
          <v-img :src="csLogo" class="cs-logo"> </v-img>
          <span>
            &copy;{{ copyRightYearRange }} CompliSpace (v{{ version }}). All rights reserved.
          </span>
        </v-layout>
      </div>
    </template>
  </cs-app>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { CSBase } from '@complispace/cs-design-system';
import tinykeys from 'tinykeys';
import csLogo from './assets/complispace-logo.png';
import { version } from '../package.json';
import * as types from './store/mutationTypes';

export default {
  name: 'App',

  extends: CSBase,

  data() {
    return {
      csLogo,
      customerLogo: `https://s3-us-west-2.amazonaws.com/develop.contentengine.compliengine.com/client-assets/212/db2d3267f4d3c75aaedbd8351433c04e-small.png`,
      items: [
        {
          text: 'single-view',
          value: 'single-view'
        },
        {
          text: 'wide-nav',
          value: 'wide-nav'
        },
        {
          text: 'narrow-nav',
          value: 'narrow-nav'
        }
      ],
      selectedView: 'single-view',
      hideSideNav: false
    };
  },

  mounted() {
    document.title = this.$store.getters['appearance/viewTitle'] || 'cs-design-system-docs';
    tinykeys(window, {
      'Control+Shift+e': () => {
        this.$store.commit(
          types.ENGINEERING_SET_TOGGLE,
          this.$store.getters['engineering/enabled']
        );
      }
    });
  },

  created() {
    this.setViewTitle('CS Design System Documentations');
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'cs-session/isLoggedIn'
    }),

    ...mapState({
      viewTypeStore: 'view-type'
    }),

    viewType: {
      get() {
        return this.viewTypeStore.viewType;
      },

      set(value) {
        this.setPageViewType(value);
        this.changeRoute(value);
      }
    },

    fingerBtn() {
      return {
        action: this.fingerBtnAction
      };
    },

    feedbackBtn() {
      return {
        action: this.feedbackBtnAction
      };
    },

    searchBtn() {
      return {
        action: this.searchBtnAction
      };
    },

    updateBtn() {
      return {
        action: this.updateBtnAction,
        id: 'check-for-updates',
        toolTip: 'Check for Updates'
      };
    },

    viewBtn() {
      return {
        action: this.viewBtnAction,
        toolTip: 'Administrator View'
      };
    },

    helpBtn() {
      return {
        action: this.helpBtnAction
      };
    },

    sideNavWidth() {
      return this.isLoggedIn && !this.hideSideNav ? 300 : 0;
    },

    version() {
      return version;
    },

    copyRightYearRange() {
      const startYear = '2018';
      return `${startYear}-${new Date().getFullYear().toString()}`;
    }
  },

  methods: {
    ...mapMutations({
      setPageViewType: types.VIEW_TYPE_SET_PAGE_VIEW_TYPE
    }),

    fingerBtnAction() {
      // eslint-disable-next-line no-alert
      alert('finger button action executed!');
    },

    feedbackBtnAction() {
      // eslint-disable-next-line no-alert
      alert('feedback button action executed!');
    },

    helpBtnAction() {
      // eslint-disable-next-line no-alert
      alert('help button action executed!');
    },

    searchBtnAction() {
      // eslint-disable-next-line no-alert
      alert('search button action executed!');
    },

    updateBtnAction() {
      // eslint-disable-next-line no-alert
      alert('update button action executed!');
    },

    viewBtnAction() {
      // eslint-disable-next-line no-alert
      alert('view button action executed!');
    },

    changeRoute(viewType) {
      switch (viewType) {
        case 'single-view':
          if (this.$route.path === '/') {
            this.$router.go();
          } else {
            this.$router.push('/');
          }
          break;
        case 'wide-nav':
          if (this.$route.path === '/wide-nav') {
            this.$router.go();
          } else {
            this.$router.push('/wide-nav');
          }
          break;
        case 'narrow-nav':
          if (this.$route.path === '/narrow-nav') {
            this.$router.go();
          } else {
            this.$router.push('/narrow-nav');
          }
          break;
        default:
          if (this.$route.path === '/') {
            this.$router.go();
          } else {
            this.$router.push('/');
          }
      }
    },

    onHideSideNav() {
      this.hideSideNav = true;
    }
  }
};
</script>

<style>
.v-footer.theme--light.v-sheet {
  background-color: white;
}

.v-footer {
  justify-content: space-around;
}
</style>
<style scoped>
.cs-logo {
  width: 200px;
  height: 50px;
}
</style>
